function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';
import startsWith from 'lodash/startsWith';
import history from 'helpers/history';
function isLeftClickEvent(event) {
    return !!event && event.button === 0;
}
function isModifiedEvent(event) {
    return !!(event && (event.metaKey || event.altKey || event.ctrlKey || event.shiftKey));
}
var _React_Component;
class Link extends (_React_Component = React.Component) {
    get isExternal() {
        return startsWith(this.props.to, 'http') || startsWith(this.props.to, '//');
    }
    handleClick(evt) {
        if (this.props.onClick) {
            this.props.onClick(evt);
        }
        if (isModifiedEvent(evt) || !isLeftClickEvent(evt)) {
            return;
        }
        if (evt.defaultPrevented === true) {
            return;
        }
        if (this.isExternal) {
            return;
        }
        evt.preventDefault();
        if (this.props.isReplace) {
            history.replace(this.props.to, this.props.pathState);
            return;
        }
        history.push(this.props.to, this.props.pathState);
    }
    render() {
        const _omit = omit(this.props, [
            'isReplace',
            'pathState'
        ]), { to, children } = _omit, props = _object_without_properties(_omit, [
            "to",
            "children"
        ]);
        return /*#__PURE__*/ _jsx("a", _object_spread_props(_object_spread({
            href: to
        }, props), {
            onClick: (evt)=>this.handleClick(evt),
            children: children
        }));
    }
}
_define_property(Link, "propTypes", {
    to: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    isReplace: PropTypes.bool,
    pathState: PropTypes.object,
    onClick: PropTypes.func
});
_define_property(Link, "defaultProps", {
    onClick: null
});
export default Link;
